import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  generateQuiz: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/quiz-generator`,
  },
  requestMoreQuiz: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/request-more-quiz`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const generateQuiz = async (params) => {
  const res = await resource.generateQuiz(params)
  return res.body
}

const requestMoreQuiz = async (params) => {
  const res = await resource.requestMoreQuiz(params)
  return res.body
}

export default {
  initResource,
  generateQuiz,
  requestMoreQuiz,
}
